/* eslint-disable react-hooks/exhaustive-deps */
//#region Styles
import { Column, Row, SubtitleSection } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import CustomTextArea from "components/CustomTextArea/CustomTextArea";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomDatePicker from "components/CustomDatePicker/CustomDatePicker";
import CustomTime from "components/CustomTimePicker/CustomTimePicker";
import CustomSelect from "components/CustomSelect/CustomSelect";
import CustomButton from "components/CustomButton/CustomButton";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion
//#region Icons
import DisketIcon from "icons/DisketIcon";
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import useAdminReservationForm from "./utils/hooks/useAdminReservationForm";
import useSpaceRegisterAdminReservation from "./utils/hooks/useSpaceRegisterAdminReservation";
//#endregion

const AdminReservationForm = ({
    updateActivityPopup,
    data: {
        spaceTypeList
    }, space, filterDate
}) => {
    const formHandler = useAdminReservationForm({ filterDate });
    const { form, errors } = formHandler;
    const registerAdminReservation = useSpaceRegisterAdminReservation({
        formHandler,
        spaceId: space.id,
        updateActivityPopup
    });
    return (
        <>
            <Container>
                <SubtitleSection align="center">
                    Registro de Reserva Administrativa
                </SubtitleSection>
                <Column gap="12px">
                    <CustomTextInput
                        label="Nombre de la reserva"
                        placeholder="Escribe el nombre de la reserva"
                        value={form.value.name}
                        onChange={form.setName}
                        maxLength={30}
                        width="100%" />
                    <CustomTextArea
                        label="Detalles"
                        placeholder="Escribe los detalles de la reserva"
                        value={form.value.details}
                        showCharCounter={false}
                        onChange={form.setDetails}
                        maxLength={200}
                        height="50px" />
                    <CustomDatePicker
                        label="Fecha"
                        value={form.value.date}
                        onChange={() => { }}
                        width="100%"
                        disabled />
                    <Row>
                        <CustomTime
                            label="Desde"
                            value={form.value.timeStart}
                            onChange={form.setTimeStart} />
                        <CustomTime
                            label="Hasta"
                            value={form.value.timeEnd}
                            onChange={form.setTimeEnd} />
                    </Row>
                    <ErrorMessage
                        error={errors.value.schedule !== null}
                        text={errors.value.schedule} />
                    <CustomSelect
                        label="Tipo de espacio"
                        value={space.spaceTypeId}
                        optionsProps={getOptionsToCustomSelect(spaceTypeList, { id: "id", text: "name" })}
                        onChange={() => { }}
                        defaultOptionText="Elige un tipo"
                        width={{
                            container: "100%",
                            containerSelect: "100%"
                        }}
                        disabled />
                    <CustomButton
                        icon={<DisketIcon />}
                        text="Registrar"
                        width="100%"
                        onClick={registerAdminReservation}
                        disabled={!form.areCompleted()} />
                </Column>
            </Container>
        </>
    );
}

export default AdminReservationForm;